import styled from 'styled-components'

export const RegionsLayout = styled.div`
	margin: 100px 0 50px 0;

	.table-container {
		display: flex;
		flex-direction: column-reverse;
		padding: 20px;
		background-color: ${props => props.theme.white};
		border-radius: 5px;
	}

	.add-user {
		width: 222px;
		margin-bottom: 20px;
	}

	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 15;

		.modal-content {
			background-color: ${props => props.theme.white};
			padding: 20px;
			border-radius: 8px;
			min-width: 400px;
			max-width: 600px;
			display: flex;
			flex-direction: column;
			gap: 10px;

			.modal-actions {
				display: flex;
				justify-content: flex-end;
				margin-top: 20px;
			}

			.modal-actions {
				.cancel {
					margin-right: 10px;
				}
				.add {
					margin-left: 10px;
				}
			}

			.err-msg {
				color: ${props => props.theme.danger};
				margin-top: 2px;
				min-height: 17px;
				font-size: 14px;
			}

			h2 {
				margin-bottom: 25px;
			}

			input {
				width: 100%;
				margin-top: 5px;
				padding: 15px 10px;
				border: none;
				outline: none;
				border-radius: 5px;
				background-color: ${props => props.theme.secondary};
				color: ${props => props.theme.fontcolor};
			}
			input:-webkit-autofill,
			input:-webkit-autofill:hover,
			input:-webkit-autofill:focus,
			input:-webkit-autofill:active {
				-webkit-box-shadow: 0 0 0 30px ${props => props.theme.secondary} inset !important;
			}
		}
	}
	.modal-enter {
		transform: translateY(100%);
	}

	.modal-enter-active {
		transform: translateY(0);
		transition: transform 0.3s ease-in-out;
	}

	.modal-exit {
		transform: translateY(0);
	}

	.modal-exit-active {
		transform: translateY(100%);
		transition: transform 0.3s ease-in-out;
	}
`
